import i18next from 'i18next';
import React, { useEffect } from 'react';
import { FormResponse } from '../../backendApi/generated';
import { MailPlusFormState } from './mailPlusFormState';
import { SpotlerFormEvent } from '../../utils/sqzl';

const useScript = (formId: number, formData: FormResponse) => {
  const script = document.createElement('script');

  script.src = formData.form.script;
  script.async = true;
  // we need to run the initialization as soon as script is loaded
  // if we don't run initShowHideForm function, the validation rules will not be applied to the form
  script.onload = () => {
    let init = window[`initShowHideform${formData.formDetails?.id}` as any] as any;

    const viewModeInput = document.querySelector('input[name="viewMode"]') as any;

    if (viewModeInput) viewModeInput.value = 'STATICINTEGRATION';

    if (init) init();

    // Hook into the form submission after validator is initialized
    const jquery = window.jQuery.noConflict();
    const formElement = jquery(`#form${formId}`);

    // Get the validator instance and set the submitHandler
    const validator = formElement.validate();
    validator.settings.submitHandler = (form: any) => {
      const formName = formData.formDetails?.name ?? "";
      // Push SQZL event with form-specific data
      SpotlerFormEvent(formId, formName);
      form.submit();
    };
  }

  document.body.appendChild(script);

  return () => {
    document.body.removeChild(script);
  }
};

export const MailPlusFormLayout = (props: MailPlusFormState & { onInvalidForm: () => JSX.Element, hasContainer: boolean }) => {

  // Update page title on load
  useEffect(() => {
    if (props.hasContainer) {
      document.title = i18next.t('form:mailPlusFormTitle');
    }
  }, []);

  useEffect(() => {
    if (props.result.kind === 'loaded') {
      useScript(Number(props.formId), props.result.value);
    }
  }, [props.result.kind]);


  if (props.result.kind === 'failed') return props.onInvalidForm()
  if (props.result.kind !== 'loaded') return <></>;
  return (

    <div className={props.hasContainer == true ? 'mpf container--s gutter--m spacing--m' : ''}
      dangerouslySetInnerHTML={{ __html: props.result.value.form.html }}
    />
  )
}
